import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
/** Styles Import */
import "./Style.css";
/** Services Import */
import Global from "../../Services/Common/Global";
import Commons from "../../Services/Common/Common";
/** Redux Import */
import { useSelector, useDispatch } from "react-redux";
import { LocalStorageActions } from "../../Redux-Reducer/LocalStorageReducer";
/** Components Import */
import { Image, Card, Button } from "react-bootstrap";
import ReactPlayer from "react-player";
import Loading from "../../Components/Loading";
import Swal from "../../Components/SweetAlert2";
import AutoTranslate from "../../Components/AutoTranslate";
/** Icons Import */
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight, faEllipsisVertical } from "@fortawesome/free-solid-svg-icons";

function SearchResult() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const searchText = useSelector((state) => state.localStorage.searchText);
  const [items, setItems] = useState(location.state?.data?.items || []);
  const [loading, setLoading] = useState(false);
  const language = useSelector((state) => state.localStorage.language);

  useEffect(() => {
    // location.state.searchText가 있으면 자동 검색
    if (location.state?.searchText) {
      handleSearch(location.state.searchText);
    }
    // eslint-disable-next-line
  }, [location.state?.searchText]);

  const handleSearch = async (keyword) => {
    setLoading(true);
    try {
      const result = await Commons.Axios("get", Global.base.useUrl + Global.urls.Content.Search, { q: keyword });
      let data = result.data;
      if (!data) {
        setItems([]);
      } else if (data.type === "Error") {
        setItems([]);
      } else {
        setItems(data.items);
      }
    } catch (e) {
      setItems([]);
    } finally {
      setLoading(false);
    }
  };

  const Sumit = async (_param) => {
    try {
      await Commons.Axios("post", `${Global.base.useUrl + Global.urls.Content.View}/${_param}`, {}, {}).then((result) => {
        let data = result.data;
        console.log("Sumit: ", data);
        if (!data) {
          throw new Error(data);
        } else if (data.type === "Error") {
          throw new Error(data.message);
        } else {
        }
      });
    } catch (e) {
      console.log("Sumit Error: ", e);
    } finally {
    }
  };

  return (
    <div className=''>
      <div className='search-result-container'>
        {loading ? (
          <div className='search-result-loading'>
            <div className='spinner-border' role='status'>
              <span className='visually-hidden'>Loading...</span>
            </div>
          </div>
        ) : items.length > 0 ? (
          items.map((item, index) => {
            return (
              <div
                key={index}
                className='search-result-item cursor-pointer'
                onClick={() => {
                  Sumit(item.id);
                  navigate("/watch", { state: { data: item, searchText: searchText } });
                }}
              >
                <div style={{ position: "relative" }}>
                  <Image className='search-result-item-image' src={item.thumbnail} alt={item.title} />
                  {item.pages ||
                    (item.duration && (
                      <div className='search-result-item-time'>
                        <span>
                          <AutoTranslate targetLanguage={language.lang}>{item.contentType === "PDF" ? item.pages : item.duration}</AutoTranslate>
                        </span>
                      </div>
                    ))}
                </div>
                <div className='search-result-item-content'>
                  <h3 className='search-result-item-title'>
                    <AutoTranslate targetLanguage={language.lang}>{item.title}</AutoTranslate>
                  </h3>
                  <p className='search-result-item-summary'>
                    <AutoTranslate targetLanguage={language.lang}>{item.summary}</AutoTranslate>
                  </p>
                </div>
              </div>
            );
          })
        ) : (
          <div className='search-result-loading'>
            <span className='search-result-item-empty'>
              <AutoTranslate targetLanguage={language.lang}>검색 결과가 없습니다.</AutoTranslate>
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default SearchResult;
